
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_4565xuuMFULoZbO_183vt2UD8Meta } from "/app/pages/[...slug].vue?macro=true";
import { default as indexdfULdhqqEDKy021fPWenouNq0J__IKzBc9M_Vrn0k0YMeta } from "/app/pages/voix/mona/index.vue?macro=true";
import { default as indexuID8p6jHlnvZorjhAjgLLjBOTgEcmgW1IpE2MQx2FIEMeta } from "/app/pages/voix/blogs/index.vue?macro=true";
import { default as indexkMXq_IPo4pKkO9zPxBvWaAXSyM9Gr1hkNAi1REr6V1MMeta } from "/app/pages/voix/menus/index.vue?macro=true";
import { default as createZ6eifyeqSnLZIUNUTMXEw3idxVP_Mqb3Uw_45LQDblth4Meta } from "/app/pages/voix/blogs/create.vue?macro=true";
import { default as indexeyK3SWmHKp1NK9aLF1Sd4eb_B5MRCs9CxKFb2UpGWR0Meta } from "/app/pages/voix/caches/index.vue?macro=true";
import { default as indexLjmmadeLdPJgyi803HJILkjoI2aSuycg5JsVzwzmRKoMeta } from "/app/pages/voix/events/index.vue?macro=true";
import { default as index7VElWfcxoYZ4Yy2Fxli6_dJ0ENGewBFP8oLtNLkC1oEMeta } from "/app/pages/voix/hotels/index.vue?macro=true";
import { default as createU_45KEuQii0c3Xnmd48Iztra9F3IRqZK3H5RjG7KgVX0wMeta } from "/app/pages/voix/menus/create.vue?macro=true";
import { default as indexCAPJAKyV_OTr4yXlObLxBPojOo4rdp_UOJOvJQvSODMMeta } from "/app/pages/voix/venues/index.vue?macro=true";
import { default as createVGLls0_4557KTIFbDn_XAp6xoOIcvFwKh2aHzzxuz4BPMMeta } from "/app/pages/voix/events/create.vue?macro=true";
import { default as createGoLkcUHbUa5sSeJIuwIwodwp8kunbsD2_m41K096TEoMeta } from "/app/pages/voix/venues/create.vue?macro=true";
import { default as index9aUJsE81kHNsZPefPcw3MVqWJ9Kw_4502fex_45BEyb5_EcMeta } from "/app/pages/voix/cobrands/index.vue?macro=true";
import { default as indexH0Dgk_45ZcrU0gkAmfsfxMYCiLo833wSxtofqdasXz6ucMeta } from "/app/pages/voix/specials/index.vue?macro=true";
import { default as _91id_93uDn15Mpp2wVWDmWkLghHYbZaEDPx1aYdjhO2AH2krekMeta } from "/app/pages/voix/blogs/edit/[id].vue?macro=true";
import { default as create5MqoxbYCTds_n4GX8n9d9SGak7pX2udoncVYxSzI1tIMeta } from "/app/pages/voix/cobrands/create.vue?macro=true";
import { default as _91id_93y_VWPMT0fIq64fpriHXaAydo34bdIPbKN1JQHLmTsMsMeta } from "/app/pages/voix/menus/edit/[id].vue?macro=true";
import { default as indexwOZrP2EztkgRVK5l_hnInYs9Vnov4bddf65i1b__hREMeta } from "/app/pages/voix/mona/logs/index.vue?macro=true";
import { default as createwlb_45xqM8R2OVY_45g_tq9G8G6uqjRIL9X8kguUj6Y8P94Meta } from "/app/pages/voix/specials/create.vue?macro=true";
import { default as indexNG3wh_OCpiInPpFNd6nhBccE6qdTMOr_45QwVZCwBA2tYMeta } from "/app/pages/voix/wait-list/index.vue?macro=true";
import { default as indexanXNoUyj4qHnW0T4XvPR4_SeK0OLJclswjIpfGPwcUYMeta } from "/app/pages/voix/error-logs/index.vue?macro=true";
import { default as _91id_939K3IRgsQFOmUgfo57jHNmzjZYkFRjoAsXpAcgytnnBwMeta } from "/app/pages/voix/events/edit/[id].vue?macro=true";
import { default as _91id_93ep4bgVHFp_RDUSXol2YFRXl4g1IVfQ4TEMLrYk_uXX8Meta } from "/app/pages/voix/hotels/edit/[id].vue?macro=true";
import { default as indexEHdTx_Ke17RqcjPnpilRMTMz8xmiXMoTOy1Qw_45Y2VOoMeta } from "/app/pages/voix/mona/pages/index.vue?macro=true";
import { default as _91id_93fQnm7eEbPZ1poTJIHALY84vLgKgZRQCYXUUwWdQts08Meta } from "/app/pages/voix/venues/edit/[id].vue?macro=true";
import { default as indexZoCxpq8fTfxY5t_45nKvv4_IeXAUcPyBeYVpuTzfpWTrIMeta } from "/app/pages/voix/movie-times/index.vue?macro=true";
import { default as indexB0wokhoOZNH_457l7XhtvqbjZnQkCTWlrLa7r_451twepZMMeta } from "/app/pages/voix/reef-owners/index.vue?macro=true";
import { default as indexyuIAyF5Kc1wmRKFHoIZC9uGZreEy1jaWn4i6kKqVm6UMeta } from "/app/pages/voix/restaurants/index.vue?macro=true";
import { default as _91id_93xv0TLjKOU_45RbtcYyKpNhqgI7MwAfwu3WPISsNGVZ_gIMeta } from "/app/pages/voix/cobrands/edit/[id].vue?macro=true";
import { default as createXPcHsZa0LLMDiQTMQoRF2CX_SmYIzBApdNpHE0obbikMeta } from "/app/pages/voix/reef-owners/create.vue?macro=true";
import { default as create54pt7dhChSjDszGDqpR3hBscEpPlA_350SjaJOeoKzUMeta } from "/app/pages/voix/restaurants/create.vue?macro=true";
import { default as _91id_93SfhwB_45lzuDIypuqbJW5deaoZABaXcve50Qn4V_ZW0noMeta } from "/app/pages/voix/specials/edit/[id].vue?macro=true";
import { default as indexE5DD4Elmp8Gw0dqX7WXE_45CyO079HcGRMyaoLhu06O5oMeta } from "/app/pages/voix/travel-agents/index.vue?macro=true";
import { default as indexESQ_45mAbURftzJ0SsqxCkcLDafpZESnFqsGjkR2pqgcsMeta } from "/app/pages/voix/url-generator/index.vue?macro=true";
import { default as indexTAS9K9OJgt0gN6vCF5zo2tk8LsJs_Y_iEinl5jYlWAMMeta } from "/app/pages/voix/press-releases/index.vue?macro=true";
import { default as createQmqJbf_45n728BiIXki_45d434P34PZvHQOVzW2X7I9JGe8Meta } from "/app/pages/voix/travel-agents/create.vue?macro=true";
import { default as create0gOkMNBJt6RInzm_QnEJP3L5MsJ4B_45D6glRuKXqEk4cMeta } from "/app/pages/voix/url-generator/create.vue?macro=true";
import { default as indexuY_45O0SfFZ7_Q6yaNcpnRSqMAEXwrc_go7_DUglYBqAkMeta } from "/app/pages/voix/calendar-alerts/index.vue?macro=true";
import { default as creategiGl3og3mFGr1BIqlkJCUZEK6e_453YranzwdbHiOHtBcMeta } from "/app/pages/voix/press-releases/create.vue?macro=true";
import { default as _91id_93PnEFN5LMuyQvYJqdpSQ_REVnY1lUAtotxGsNng_45yT1cMeta } from "/app/pages/voix/reef-owners/edit/[id].vue?macro=true";
import { default as _91id_935Dlul3q8EQh9zE6a4m5Qeg7i93Zvw35NWKWnodUzHqAMeta } from "/app/pages/voix/restaurants/edit/[id].vue?macro=true";
import { default as _91id_93gETAvt8cM3if8nr7z2K2Xwyb9v_Fq5CFZ2hLozGq7aEMeta } from "/app/pages/voix/travel-agents/edit/[id].vue?macro=true";
import { default as _91id_93d4CzM81qBvPZ4ZtPWSdgZ_i0ET7GXfX9lLDrxGuC6tkMeta } from "/app/pages/voix/url-generator/edit/[id].vue?macro=true";
import { default as _91id_93G2Coc_ddXCTGfCJCy9__IHXxJsBtlRkh5XJKluaNnJgMeta } from "/app/pages/voix/press-releases/edit/[id].vue?macro=true";
import { default as indexbTt7FhejghvL_XFyV6XKf1ndJeV4HWeS5Hzuubl1o9gMeta } from "/app/pages/voix/reef-owners-archive/index.vue?macro=true";
import { default as indexbVDWNFapl08FSaJjGDSDIQSThkcpOeEgFuaY_45ijpP2QMeta } from "/app/pages/voix/specials-categories/index.vue?macro=true";
import { default as createTB3hE0dW0nGQbYDplVIRlY79ImLx0Gk_Ppe8qIWJOmsMeta } from "/app/pages/voix/reef-owners-archive/create.vue?macro=true";
import { default as createIhdaIKpvGpeJI3RNgizoqjA1nD0iTHq_QZwgEUUlE_45EMeta } from "/app/pages/voix/specials-categories/create.vue?macro=true";
import { default as _91id_937soWHHYizMNo4ViGEdit3yp0Xolvw2wbfqbrQMoJu50Meta } from "/app/pages/voix/reef-owners-archive/edit/[id].vue?macro=true";
import { default as _91id_93OWirH1iUVzO9yiZDmdNvryWJNIIpWYlrW46KOCkfhMYMeta } from "/app/pages/voix/specials-categories/edit/[id].vue?macro=true";
import { default as voix_45debughTo3Mb116y_45VxTViAeK_45ZwAejqnmSZ3EUWpC96XJGY8Meta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/voix-debug.vue?macro=true";
import { default as Preview4_45rAAFIWyws9qkDkwIDOK9K4wXKHFjy3cjJPcJaUc_45sMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/releases/Preview.vue?macro=true";
import { default as IndexY_451K8SPHfcz_zKcZqXYqYtTwlWX0IXEISM3_45VOcAVhEMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/settings-menu/Index.vue?macro=true";
import { default as loginQDNAVwH3wM8Ri4EJLqH0Fn1tNZG0l5ZPs7blebA2v_450Meta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/auth/login.vue?macro=true";
import { default as callback_45p8rbXre3l8I8YT3SwcFxfaz99w2Uj91NNwkJc9lyqwMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/auth/callback.vue?macro=true";
import { default as studioScNna8e7pCr9bpZxYHA6B7hr_ac6vx6QFn1zL1We5CYMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/studio.vue?macro=true";
import { default as IndexkGjX5bs_Yp_45HOioL9g89szaEqQjVAETSrbtrohQSl_45AMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Index.vue?macro=true";
import { default as EditexIE5S9DXU17hzuOOeubytOZ4TH3maBRxrD0S3fTUTYMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Edit.vue?macro=true";
import { default as CreateSnDwOAvIRpv_PFYTY3K95YoM_eS0yJxApm94q38UxYEMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Create.vue?macro=true";
import { default as IndexJGeGwuNvRF0gQlnd5ngrMjY_458WzcTRXE6AdvVsiiA2UMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Index.vue?macro=true";
import { default as CreateW8_x9LGsR_SlgkSR0GcsjAhS3j2r0JLRlg0xLCGCbkEMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Create.vue?macro=true";
import { default as TranslateF5Jk58glG00pBR5hIXrHwnbcKBoqao7SMqSfLYLBPewMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Translate.vue?macro=true";
import { default as CopyEUL_2fsv8Wmh1qouzUcNmuLDuTiMtZHVx9Sjr9jqIcIMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Copy.vue?macro=true";
import { default as Index2Lsn5xRwHX5PcWVmS0fqDKGm6McYup_458vwwGbXF6jooMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/releases/Index.vue?macro=true";
import { default as IndexyF_459RFOUCc7ufe0eVBzLWKsjJsMHSRiWCbWRylIwOukMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Index.vue?macro=true";
import { default as EditnMVQ5s9wavU237CmxcnX8HA3jNGvTiDL5H54_UwOCLMMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Edit.vue?macro=true";
import { default as CreateKFARmfeuzd8cHso3PRDBkKw9qhLiuVHTEpuorQe4_45hoMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Create.vue?macro=true";
import { default as IndexqDeby6KETb7HoR8SGW_45sWNz_ap7qXzvEvlQz0AmloJ4Meta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Index.vue?macro=true";
import { default as Create0_45dbNgR1qcgrUzydW27UpUpuTFR6VBBi1k9xUXWg4q4Meta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Create.vue?macro=true";
import { default as EditESJwGnQfvyZfc30oCL77DlOxTj5GgVAp_45yFIHjWr6rAMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Edit.vue?macro=true";
import { default as Profile_rbboNFifXkd9lONxewBMBjAqj_eepI4KPcMUWicUxIMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Profile.vue?macro=true";
import { default as indexDGW7LT7ueI2WsHgpn5h4V1h3lOqDQHf03vXsxwp9cOkMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/cookbook/index.vue?macro=true";
import { default as SlicesView4rCEuQAXFTb2enL6UABf8aV_45lJexzMJ_45afUZHPto7uQMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/SlicesView.vue?macro=true";
import { default as TemplateViewtE2VfxbKQlGHHVE6mkHe4t_45q7X_45sWSAjVrEH1vdcSvQMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/TemplateView.vue?macro=true";
import { default as DesignGuideView6Eiyh_45QaaRWwEpuGs584mlwlVmyScBbDOLNIvlpXTCYMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/DesignGuideView.vue?macro=true";
import { default as slicervsyJtFEqWu7wT4oFe5UEaqUFjqTqMhILMWfkk6T7a_45gMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/slicer.vue?macro=true";
import { default as documentQIzUAlgJBPvzMl6Q3aJDEvztl_454QEm5k9NXrB15dG48Meta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/documentation/document.vue?macro=true";
import { default as voixNYDGR87sCigZAgl8cNO9VjzF2dGGa6aVqPyNTpVZVyEMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/voix.vue?macro=true";
import { default as SlicePreviewJLc3u2hcsx7xCRAHvW42OTjWrnxIMBqW2KbmqDFO260Meta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/SlicePreview.vue?macro=true";
import { default as previewFaoL3Fw88qmVd3fnv0YMevz2mfW_2Tj3q800hY4W6zIMeta } from "/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/cookbook/preview.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "voix-mona",
    path: "/voix/mona",
    component: () => import("/app/pages/voix/mona/index.vue")
  },
  {
    name: "voix-blogs",
    path: "/voix/blogs",
    component: () => import("/app/pages/voix/blogs/index.vue")
  },
  {
    name: "voix-menus",
    path: "/voix/menus",
    component: () => import("/app/pages/voix/menus/index.vue")
  },
  {
    name: "voix-blogs-create",
    path: "/voix/blogs/create",
    component: () => import("/app/pages/voix/blogs/create.vue")
  },
  {
    name: "voix-caches",
    path: "/voix/caches",
    component: () => import("/app/pages/voix/caches/index.vue")
  },
  {
    name: "voix-events",
    path: "/voix/events",
    component: () => import("/app/pages/voix/events/index.vue")
  },
  {
    name: "voix-hotels",
    path: "/voix/hotels",
    component: () => import("/app/pages/voix/hotels/index.vue")
  },
  {
    name: "voix-menus-create",
    path: "/voix/menus/create",
    component: () => import("/app/pages/voix/menus/create.vue")
  },
  {
    name: "voix-venues",
    path: "/voix/venues",
    component: () => import("/app/pages/voix/venues/index.vue")
  },
  {
    name: "voix-events-create",
    path: "/voix/events/create",
    component: () => import("/app/pages/voix/events/create.vue")
  },
  {
    name: "voix-venues-create",
    path: "/voix/venues/create",
    component: () => import("/app/pages/voix/venues/create.vue")
  },
  {
    name: "voix-cobrands",
    path: "/voix/cobrands",
    component: () => import("/app/pages/voix/cobrands/index.vue")
  },
  {
    name: "voix-specials",
    path: "/voix/specials",
    component: () => import("/app/pages/voix/specials/index.vue")
  },
  {
    name: "voix-blogs-edit-id",
    path: "/voix/blogs/edit/:id()",
    component: () => import("/app/pages/voix/blogs/edit/[id].vue")
  },
  {
    name: "voix-cobrands-create",
    path: "/voix/cobrands/create",
    component: () => import("/app/pages/voix/cobrands/create.vue")
  },
  {
    name: "voix-menus-edit-id",
    path: "/voix/menus/edit/:id()",
    component: () => import("/app/pages/voix/menus/edit/[id].vue")
  },
  {
    name: "voix-mona-logs",
    path: "/voix/mona/logs",
    component: () => import("/app/pages/voix/mona/logs/index.vue")
  },
  {
    name: "voix-specials-create",
    path: "/voix/specials/create",
    component: () => import("/app/pages/voix/specials/create.vue")
  },
  {
    name: "voix-wait-list",
    path: "/voix/wait-list",
    component: () => import("/app/pages/voix/wait-list/index.vue")
  },
  {
    name: "voix-error-logs",
    path: "/voix/error-logs",
    component: () => import("/app/pages/voix/error-logs/index.vue")
  },
  {
    name: "voix-events-edit-id",
    path: "/voix/events/edit/:id()",
    component: () => import("/app/pages/voix/events/edit/[id].vue")
  },
  {
    name: "voix-hotels-edit-id",
    path: "/voix/hotels/edit/:id()",
    component: () => import("/app/pages/voix/hotels/edit/[id].vue")
  },
  {
    name: "voix-mona-pages",
    path: "/voix/mona/pages",
    component: () => import("/app/pages/voix/mona/pages/index.vue")
  },
  {
    name: "voix-venues-edit-id",
    path: "/voix/venues/edit/:id()",
    component: () => import("/app/pages/voix/venues/edit/[id].vue")
  },
  {
    name: "voix-movie-times",
    path: "/voix/movie-times",
    component: () => import("/app/pages/voix/movie-times/index.vue")
  },
  {
    name: "voix-reef-owners",
    path: "/voix/reef-owners",
    component: () => import("/app/pages/voix/reef-owners/index.vue")
  },
  {
    name: "voix-restaurants",
    path: "/voix/restaurants",
    component: () => import("/app/pages/voix/restaurants/index.vue")
  },
  {
    name: "voix-cobrands-edit-id",
    path: "/voix/cobrands/edit/:id()",
    component: () => import("/app/pages/voix/cobrands/edit/[id].vue")
  },
  {
    name: "voix-reef-owners-create",
    path: "/voix/reef-owners/create",
    component: () => import("/app/pages/voix/reef-owners/create.vue")
  },
  {
    name: "voix-restaurants-create",
    path: "/voix/restaurants/create",
    component: () => import("/app/pages/voix/restaurants/create.vue")
  },
  {
    name: "voix-specials-edit-id",
    path: "/voix/specials/edit/:id()",
    component: () => import("/app/pages/voix/specials/edit/[id].vue")
  },
  {
    name: "voix-travel-agents",
    path: "/voix/travel-agents",
    component: () => import("/app/pages/voix/travel-agents/index.vue")
  },
  {
    name: "voix-url-generator",
    path: "/voix/url-generator",
    component: () => import("/app/pages/voix/url-generator/index.vue")
  },
  {
    name: "voix-press-releases",
    path: "/voix/press-releases",
    component: () => import("/app/pages/voix/press-releases/index.vue")
  },
  {
    name: "voix-travel-agents-create",
    path: "/voix/travel-agents/create",
    component: () => import("/app/pages/voix/travel-agents/create.vue")
  },
  {
    name: "voix-url-generator-create",
    path: "/voix/url-generator/create",
    component: () => import("/app/pages/voix/url-generator/create.vue")
  },
  {
    name: "voix-calendar-alerts",
    path: "/voix/calendar-alerts",
    component: () => import("/app/pages/voix/calendar-alerts/index.vue")
  },
  {
    name: "voix-press-releases-create",
    path: "/voix/press-releases/create",
    component: () => import("/app/pages/voix/press-releases/create.vue")
  },
  {
    name: "voix-reef-owners-edit-id",
    path: "/voix/reef-owners/edit/:id()",
    component: () => import("/app/pages/voix/reef-owners/edit/[id].vue")
  },
  {
    name: "voix-restaurants-edit-id",
    path: "/voix/restaurants/edit/:id()",
    component: () => import("/app/pages/voix/restaurants/edit/[id].vue")
  },
  {
    name: "voix-travel-agents-edit-id",
    path: "/voix/travel-agents/edit/:id()",
    component: () => import("/app/pages/voix/travel-agents/edit/[id].vue")
  },
  {
    name: "voix-url-generator-edit-id",
    path: "/voix/url-generator/edit/:id()",
    component: () => import("/app/pages/voix/url-generator/edit/[id].vue")
  },
  {
    name: "voix-press-releases-edit-id",
    path: "/voix/press-releases/edit/:id()",
    component: () => import("/app/pages/voix/press-releases/edit/[id].vue")
  },
  {
    name: "voix-reef-owners-archive",
    path: "/voix/reef-owners-archive",
    component: () => import("/app/pages/voix/reef-owners-archive/index.vue")
  },
  {
    name: "voix-specials-categories",
    path: "/voix/specials-categories",
    component: () => import("/app/pages/voix/specials-categories/index.vue")
  },
  {
    name: "voix-reef-owners-archive-create",
    path: "/voix/reef-owners-archive/create",
    component: () => import("/app/pages/voix/reef-owners-archive/create.vue")
  },
  {
    name: "voix-specials-categories-create",
    path: "/voix/specials-categories/create",
    component: () => import("/app/pages/voix/specials-categories/create.vue")
  },
  {
    name: "voix-reef-owners-archive-edit-id",
    path: "/voix/reef-owners-archive/edit/:id()",
    component: () => import("/app/pages/voix/reef-owners-archive/edit/[id].vue")
  },
  {
    name: "voix-specials-categories-edit-id",
    path: "/voix/specials-categories/edit/:id()",
    component: () => import("/app/pages/voix/specials-categories/edit/[id].vue")
  },
  {
    name: "voix-debug",
    path: "/voix-debug",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/voix-debug.vue")
  },
  {
    name: "voix-preview-release-entry-en",
    path: "/preview-release/:releaseId/:previewSecret",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/releases/Preview.vue")
  },
  {
    name: "voix",
    path: "/voix",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/voix.vue"),
    children: [
  {
    name: "voix-settings-en",
    path: "",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/settings-menu/Index.vue")
  },
  {
    name: "voix-login-en",
    path: "login",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/auth/login.vue")
  },
  {
    name: "voix-auth-callback-en",
    path: "auth/callback",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/auth/callback.vue")
  },
  {
    name: "voix-studio-en",
    path: "studio",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/studio.vue")
  },
  {
    name: "voix-settings-head-tags-en",
    path: "head-tags",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Index.vue")
  },
  {
    name: "voix-settings-head-tags-edit-en",
    path: "head-tags/:id",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Edit.vue")
  },
  {
    name: "voix-settings-head-tags-create-en",
    path: "head-tags/create",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/head-tags/Create.vue")
  },
  {
    name: "voix-settings-pages-en",
    path: "pages",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Index.vue")
  },
  {
    name: "voix-settings-pages-create-en",
    path: "pages/create",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Create.vue")
  },
  {
    name: "voix-settings-pages-translate-en",
    path: "pages/translate",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Translate.vue")
  },
  {
    name: "voix-settings-pages-copy-en",
    path: "pages/copy",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/pages/Copy.vue")
  },
  {
    name: "voix-settings-releases-en",
    path: "releases",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/releases/Index.vue")
  },
  {
    name: "voix-settings-redirects-en",
    path: "redirects",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Index.vue")
  },
  {
    name: "voix-settings-redirects-edit-en",
    path: "redirects/:id",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Edit.vue")
  },
  {
    name: "voix-settings-redirects-create-en",
    path: "redirects/create",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/redirects/Create.vue")
  },
  {
    name: "voix-settings-users-en",
    path: "users",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Index.vue")
  },
  {
    name: "voix-settings-users-create-en",
    path: "users/create",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Create.vue")
  },
  {
    name: "voix-settings-users-edit-en",
    path: "users/:id",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Edit.vue")
  },
  {
    name: "voix-settings-users-profile-en",
    path: "profile",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/users/Profile.vue")
  },
  {
    name: "voix-cookbook-en",
    path: "cookbook",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/cookbook/index.vue")
  },
  {
    name: "voix-slicer-en",
    path: "slicer",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/slicer.vue"),
    children: [
  {
    name: "voix-slicer-slices-en",
    path: "",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/SlicesView.vue")
  },
  {
    name: "voix-slicer-template-en",
    path: "templates/:templateName",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/TemplateView.vue")
  },
  {
    name: "voix-slicer-design-guide-en",
    path: "design-guide",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/DesignGuideView.vue")
  }
]
  },
  {
    name: "voix-documentation-en",
    path: "documentation/:documentPath(.*)?",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/documentation/document.vue")
  }
]
  },
  {
    name: "slicer-slice-en",
    path: "/voix/slice-preview/:sliceName",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/components/slicer/views/SlicePreview.vue")
  },
  {
    name: "cookbook-preview-en",
    path: "/voix/cookbook-preview/:recipe(.*)",
    component: () => import("/app/node_modules/@logicbomb-media/voix/dist/runtime/pages/cookbook/preview.vue")
  }
]